module.exports = __webpack_public_path__ + "static/media/poppins-v5-latin-ext-700.1ad68bab.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/poppins-v5-latin-ext-700.woff2
// module id = ./src/common/fonts/poppins-v5-latin-ext-700.woff2
// module chunks = 1